// extracted by mini-css-extract-plugin
export default {"vacancySection":"styles_vacancySection__1+062","spinner":"styles_spinner__ZoRDX"};